export const initialFormValues = {
  email: '',
  password: '',
}

export const MAX_ATTEMPS_COUNT = 3

export const LOGIN_REJECTED_TYPE = 'auth/login/rejected'
